<script lang="ts" setup>
import { useMate } from "@/stores/mate";
import { useRouter } from "vue-router";
import { showImagePreview, showLoadingToast } from "vant";
import { useGlobalUser } from "@/stores/globalUser";
import { HOME_ROUTER } from "@/use/go";

const globalUserStore = useGlobalUser();
const mateStore = useMate();
const router = useRouter();

const onDownload = () => {
  showImagePreview({
    images: [mateStore.currentMate!.mediaUrl],
    startPosition: 0,
  });
};
const onEnterCommunity = async () => {
  const loading = showLoadingToast("");
  try {
    await globalUserStore.afterLogin();
    await router.push(HOME_ROUTER);
  } catch {
    await router.push(HOME_ROUTER);
    window.location.reload();
  } finally {
    loading.close();
  }
};
</script>
<template>
  <div class="flex flex-col gap-10 items-center justify-center">
    <div class="text-white text-[2rem] font-bold text-center">
      {{ $t("loginmodal.welcome") }}
    </div>
    <div class="flex flex-col gap-2 items-center">
      <div
        class="rounded overflow-hidden shadow-lg pointer-events-none aspect-[3/4] w-32 md:w-64"
      >
        <img
          :src="`${mateStore.currentMate?.mediaUrl}?x-oss-process=image/resize,w_300/format,webp/quality,q_80`"
          alt=""
          class="object-contain w-full"
        />
      </div>
      <div class="flex gap-2 items-center">
        <button class="btn btn-neutral rounded flex-1" @click="onDownload">
          {{ $t("loginmodal.downloadImage") }}
        </button>
        <button
          class="btn btn-primary rounded flex-1"
          @click="onEnterCommunity"
        >
          {{ $t("loginmodal.enterCommunity") }}
        </button>
      </div>
      <div class="text-center">
        {{ $t("loginmodal.downloadAvatarTip") }}
      </div>
    </div>
  </div>
</template>
